import React from "react";
import "./../styles/Population.css";

// Icons
import { FaUserGroup } from "react-icons/fa6";
import { HiCursorClick } from "react-icons/hi";

const Population = () => {
  return (
    <>
    <div id="scrollspypopulation" className="container-fluid text-center py-4">
      <div className="row align-items-center bg-secondary bg-opacity-10 mt-4 px-3 py-5 ps-md-5">
        <div className="col-md-6">
          <h3
            
            className="text-secondary fw-semibold text-start"
          >
            Helping a local <br />
            <span className="textSpan">business reinvent itself</span>
          </h3>
          <p className="text-secondary text-start">
            We reached here with our hard work and dedication
          </p>
        </div>
        <div className="col-md-6">
          <div className="container text-center">
            <div className="row">
              <div className="col-6 col-md-6 px-2 d-flex align-items-center">
                <div className="memberIcon pe-4">
                  <FaUserGroup />
                </div>
                <div className="members">
                  <h4 className="mb-0 text-secondary">162</h4>
                  <p className="mb-0 text-secondary">Members</p>
                </div>
              </div>
              <div className="col-6 col-md-6 px-2 d-flex align-items-center">
                <div className="viewsIcon">
                  <HiCursorClick />
                </div>
                <div className="views">
                  <h4 className="mb-0 text-secondary">1,991</h4>
                  <p className="mb-0 text-secondary">Views</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Population;
